module.exports = "mutation setToProcessing($processingInput:ProcessingInput!){setToProcessing(processingInput:$processingInput)}"